<template>
  <div class="message-input" :class="{ 'message-input--dark': isDarkMode }">
    <textarea
      ref="textarea"
      v-model="text"
      class="message-input__textarea"
      :class="{ 'message-input__textarea--dark': isDarkMode }"
      placeholder="Type a message..."
      :disabled="streaming"
      @keydown.enter.exact.prevent="handleSend"
    ></textarea>
    <button
      class="message-input__send-btn"
      :disabled="!canSend"
      @click="handleSend"
      aria-label="Send message"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18" fill="currentColor"><path d="M476.59 227.05l-.16-.07L49.35 49.84A23.56 23.56 0 0027.14 52 24.65 24.65 0 0016 73.2v119.46a24 24 0 0019.52 23.57l232.93 43.07a4 4 0 010 7.86L35.53 310.4A24 24 0 0016 333.97V453.4a24.65 24.65 0 0011.14 21.23 23.56 23.56 0 0022.21 2.13l427.08-177.14.16-.07a24.65 24.65 0 000-45.5z"/></svg>
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'MessageInput',
  data() {
    return {
      text: ''
    };
  },
  computed: {
    ...mapState('chat', ['streaming']),
    ...mapState('darkMode', ['isDarkMode']),
    canSend() {
      return this.text.trim().length > 0 && !this.streaming;
    }
  },
  methods: {
    handleSend() {
      if (!this.canSend) return;
      this.$emit('send', this.text.trim());
      this.text = '';
    }
  }
};
</script>

<style scoped>
.message-input {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #e0e0e0;
  background: #fff;
  flex-shrink: 0;
}

.message-input--dark {
  border-top-color: #555;
  background: #343a40;
}

.message-input__textarea {
  flex: 1;
  min-height: 44px;
  max-height: 120px;
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  resize: none;
  font-family: inherit;
  font-size: 0.95rem;
  line-height: 1.4;
  outline: none;
  background: #fff;
  color: #2c3e50;
}

.message-input__textarea--dark {
  background: #464d54;
  color: #f0f0f0;
  border-color: #666;
}

.message-input__textarea:focus {
  border-color: #F28A3E;
}

.message-input__textarea:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.message-input__send-btn {
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background-color: #F28A3E;
  color: #fff;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.message-input__send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.message-input__send-btn:not(:disabled):hover {
  background-color: #e07a2e;
}
</style>
